import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon21: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#73C177"
        d="M13.5 0a.5.5 0 0 1 .5.5v19a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5V.5A.5.5 0 0 1 .5 0h13ZM13 1H1v18h12V1ZM6.982 9.5a.5.5 0 0 1 .5.5l.001.371a3.8 3.8 0 0 1 1.05.406.5.5 0 0 1-.518.856 2.378 2.378 0 0 0-.345-.162 2.206 2.206 0 0 0-.785-.166c-.475 0-.777.207-.777.439 0 .279.26.47 1.115.808l.088.035c1.199.475 1.657.799 1.657 1.609 0 .829-.587 1.336-1.485 1.473v.34a.5.5 0 0 1-1 0l-.001-.335a2.766 2.766 0 0 1-.825-.243 1.736 1.736 0 0 1-.486-.329.5.5 0 1 1 .72-.694c.015.016.08.065.2.122.225.109.514.176.875.176.697 0 1.002-.197 1.002-.51 0-.201-.232-.365-1.025-.679l-.089-.035c-1.244-.493-1.746-.86-1.746-1.738 0-.755.596-1.273 1.374-1.405V10a.5.5 0 0 1 .5-.5ZM10.5 7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h7Zm0-3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h7Z"
      />
    </Svg>
  )
}
